import { useEffect } from 'react';

// Janela de atendimento da Área do Cliente: widget da Ayla.
// Substitui o Freshchat, cuja conta no Freshworks é cancelada em 31/10/2026.
// Snippet e init conforme lya-frontend widget/docs/instalacao-em-site.md.
// A chave é pública (vai no código da página de qualquer jeito), mas vem do ambiente de build e
// não do repositório: quem controla o acesso é a lista de origens permitidas, no painel da Ayla.
// Variável ausente = widget desligado, com aviso.
function loadAylaWidget() {
  const installKey = process.env.REACT_APP_AYLA_WIDGET_KEY;
  const panelUrl = process.env.REACT_APP_AYLA_PANEL_URL;
  if (!installKey || !panelUrl) {
    console.warn(
      'Ayla: REACT_APP_AYLA_WIDGET_KEY ou REACT_APP_AYLA_PANEL_URL vazio; nenhum widget carregado.',
    );
    return;
  }
  if (document.getElementById('ayla-widget-loader')) {
    return;
  }

  // Stub de fila: chamadas feitas antes de o loader.js carregar entram na fila.
  if (!window.KenloWidget) {
    const queue: [string, unknown[]][] = [];
    const stub: Record<string, unknown> = { q: queue };
    ['init', 'setContext', 'sendEvent', 'ask', 'on', 'off', 'open', 'close'].forEach((method) => {
      stub[method] = (...args: unknown[]) => queue.push([method, args]);
    });
    window.KenloWidget = stub as unknown as Window['KenloWidget'];
  }

  window.KenloWidget?.init({
    installKey,
    // Lido a cada pedido do widget: o idToken do Cognito leva e-mail e imobiliária.
    // Null depois que o usuário sai.
    getToken: () => Promise.resolve(localStorage.getItem('idToken')),
  });

  const script = document.createElement('script');
  script.src = panelUrl.replace(/\/+$/, '') + '/widget/loader.js';
  script.async = true;
  script.id = 'ayla-widget-loader';
  script.onerror = () =>
    console.error(`Ayla: falha ao carregar ${script.src}; usuário fica sem atendimento.`);
  document.body.appendChild(script);
}

export const FreshDeskLoader = () => {
  useEffect(() => {
    loadAylaWidget();
  }, []);

  return null;
};

// Botões "falar com a gente" espalhados pelas telas.
export function openChat() {
  window.KenloWidget?.open();
}

// Os botões que alternavam a janela: a Ayla não expõe o estado, então abrir é o
// comportamento útil — fechar é o X da própria janela.
export function toggleChat() {
  window.KenloWidget?.open();
}

// Ao sair: a Ayla não tem logout e a sessão do usuário vive na memória do iframe.
// Fecha e recarrega; depois da recarga o loader não está mais na página.
export function clearAylaChat() {
  if (!document.getElementById('ayla-widget-loader')) {
    return;
  }
  window.KenloWidget?.close();
  window.location.reload();
}
